"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = require("../main");
var constantsClasses_1 = require("../data/constantsClasses");
var constants_1 = require("../data/constants");
var Modal = /** @class */ (function () {
    function Modal(modalTypeName) {
        this.element = document.querySelector("[".concat(constants_1.DATA_MODAL, "=\"").concat(modalTypeName, "\"]"));
        if (!this.getElement())
            return;
        this.type = modalTypeName;
        this.triggerEl = document.querySelector("[".concat(constants_1.DATA_MODAL_TRIGGER, "=\"").concat(modalTypeName, "\"]"));
        this.closeBtn = this.getElement().querySelector("[".concat(constants_1.DATA_MODAL_CLOSE, "]"));
        this.faqBtn = this.getElement().querySelector("[".concat(constants_1.DATA_MODAL_FAQ, "]"));
        this.header = document.querySelector("[".concat(constants_1.DATA_HEADER, "]"));
        this.initEventListeners();
        this.initObserver();
    }
    Modal.prototype.initEventListeners = function () {
        var _this = this;
        var _a, _b, _c;
        (_a = this.triggerEl) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
            _this.toggleModal();
            main_1.trengoModal.hideModal();
        });
        (_b = this.closeBtn) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function () {
            _this.hideModal();
        });
        (_c = this.faqBtn) === null || _c === void 0 ? void 0 : _c.addEventListener('click', function () {
            _this.hideModal();
            main_1.trengoModal.showModal();
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                _this.hideModal();
            }
        });
        document.addEventListener('click', function (event) {
            _this.checkForOutsideClick(event);
        });
    };
    Modal.prototype.getElement = function () {
        return this.element;
    };
    Modal.prototype.isActive = function () {
        return this.getElement().classList.contains(constantsClasses_1.CLASS_ACTIVE);
    };
    Modal.prototype.toggleModal = function () {
        this.getElement().classList.toggle(constantsClasses_1.CLASS_ACTIVE);
        this.triggerEl.classList.toggle(constantsClasses_1.CLASS_ACTIVE);
        this.header.classList.toggle(constantsClasses_1.CLASS_MODAL_OPEN);
    };
    Modal.prototype.showModal = function () {
        this.getElement().classList.add(constantsClasses_1.CLASS_ACTIVE);
        this.triggerEl.classList.add(constantsClasses_1.CLASS_ACTIVE);
        this.header.classList.add(constantsClasses_1.CLASS_MODAL_OPEN);
    };
    Modal.prototype.hideModal = function () {
        this.getElement().classList.remove(constantsClasses_1.CLASS_ACTIVE);
        this.triggerEl.classList.remove(constantsClasses_1.CLASS_ACTIVE);
        this.header.classList.remove(constantsClasses_1.CLASS_MODAL_OPEN);
    };
    // Close modal on outside click
    Modal.prototype.checkForOutsideClick = function (event) {
        var elements = event.composedPath();
        // -2 because we want to skip document and window (unless you are not using document as parent)
        for (var i = 0; i < elements.length - 2; i++) {
            var el = elements[i];
            // Don't trigger if modal is targeted
            if (el.getAttribute('data-modal') == this.type ||
                el.getAttribute('data-modal-trigger') == this.type) {
                return;
            }
        }
        this.hideModal();
    };
    // Register IntersectionObserver and close modal on footer
    Modal.prototype.initObserver = function () {
        var _this = this;
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.intersectionRatio > 0) {
                    _this.hideModal();
                }
            });
        });
        var el = document.querySelector('.footer');
        io.observe(el);
    };
    return Modal;
}());
exports.default = Modal;
